import {
  API_BASE_URL,
  RAYCHAT_IMAGES_URL,
  RAYCHAT_WIDGET_INSTALL_URL,
} from './constants';
import { PROTOCOL_REGEX } from './regex';

export const getDomainFromUrl = (url) => {
  return url && url.replace(PROTOCOL_REGEX, '');
};

export const redirectToPaymentPort = (invoiceId) => {
  const address = API_BASE_URL + `/ipg/vandar/pay?invoiceId=${invoiceId}`;
  window.location.href = address;

  // const paymentLink = document.createElement('a');
  // paymentLink.id = 'paymentLink';
  // paymentLink.href = API_BASE_URL + `/ipg/vandar/pay?invoiceId=${invoiceId}`;
  // document.body.appendChild(paymentLink);
  // const paymentLinkElem = document.getElementById('paymentLink');
  // paymentLinkElem.click();
  // paymentLinkElem.parentNode.removeChild(paymentLinkElem);
};

export const redirectToPaymentPortEng = (invoiceId) => {
  const address = API_BASE_URL + `/ipg/paypal/redirect/${invoiceId}`;

  window.location.href = address;
};

export const redirectToAutoUpgrade = (url) => {
  const paymentLink = document.createElement('a');
  paymentLink.id = 'paymentLink';
  paymentLink.href = url;
  document.body.appendChild(paymentLink);
  const paymentLinkElem = document.getElementById('paymentLink');
  paymentLinkElem.click();
  paymentLinkElem.parentNode.removeChild(paymentLinkElem);
};

/**
 * As we have kind of inconsistency  in returned iamge URLs from backend. so a normalizer is required.
 * This function checks for these 3 unnormal urls and normalizes them:
 *
 * 1 - urls without base url (starting with /)
 * 2- urls without base url (not starting with /)
 * 3 - urlls with two base urls
 *
 * @param {string} url - iamge address
 * @param {string} baseUrl - base url
 *
 * @returns {string}
 */
export const getNormalizedUrl = (url = '', baseUrl = RAYCHAT_IMAGES_URL) => {
  if (!url.startsWith('http')) {
    url = `${baseUrl}/${url.replace(/^\/+/, '')}`;
  }

  const baseUrlPattern = new RegExp(`(${baseUrl})\\/\\1+`);

  return url.replace(baseUrlPattern, baseUrl);
};

export const getAvatarUrl = (apiUrl) => {
  const url = apiUrl || '/images/avatar-agent-default.svg';

  return getNormalizedUrl(url);
};

export const getWidgetInstallSrcUrl = (locale) => {
  // Note: use this for different getting install URL based on language
  // const INSTALL_EN_URL = RAYCHAT_WIDGET_INSTALL_URL + '?lang=en';
  const INSTALL_FA_URL = RAYCHAT_WIDGET_INSTALL_URL;

  // return locale === 'en' ? INSTALL_EN_URL : INSTALL_FA_URL;

  return INSTALL_FA_URL;
};

// this function returns decoded urls if they exist and are not malformed.
export const getDecodedURL = (url) => {
  try {
    if (url) {
      return decodeURI(url);
    }
    return url;
    // in case of malformed url
  } catch (error) {
    return url;
  }
};
